import { useEffect } from 'react';
import { useAppState } from 'AppProvider';
import {
  removeMemberAnalyticsData,
  setMemberAnalyticsData,
} from 'features/analytics';
import { RewardProgramState } from 'reducers/rewardProgramIntegration';

export const useMemberAnalyticsTracker = () => {
  const rewardProgram: RewardProgramState = useAppState(
    (state: Record<string, unknown>) => state.rewardProgramIntegration,
  );
  const rewardProgramIntegration = rewardProgram?.rewardProgramIntegration;

  useEffect(() => {
    if (!rewardProgramIntegration) {
      removeMemberAnalyticsData();
      return;
    }
    setMemberAnalyticsData(rewardProgramIntegration);
  }, [rewardProgramIntegration]);
};
